import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IDeleteEventRequest extends IBaseRequest {
    ident?:          string;
    multiChange?:    string;
    multiEventTask?: string;
    headId?:         string;
}

export class DeleteEventRequest extends BaseRequest implements IDeleteEventRequest {
    public ident?:          string;
    public multiChange?:    string;
    public multiEventTask?: string;
    public headId?:         string;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.ident = otherOptions.ident;
    this.multiChange = otherOptions.multiChange;
    this.multiEventTask = otherOptions.multiEventTask;
    this.headId = otherOptions.headId;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.ident, 'ident');
    parameters += this.makeNode(this.multiChange, 'multiChange');
    parameters += this.makeNode(this.multiEventTask, 'multiEventTask');
    parameters += this.makeNode(this.headId, 'headId');

    return super.wrapperXml('DeleteEvent', parameters);
  }
}
